module.exports = __webpack_public_path__ + "img/7e682552-0dfe-428a-8a9d-d6076b08b8c4.9d0032b5.jpg";